export const CVSProductData = [
  {
    query: `SELECT param2.value.string_value as product_id, count(1) AS value
    FROM \`cvs-vividplay.analytics_257379716.events_*\`,
    UNNEST(event_params) AS param2
    WHERE event_name = 'vv_barcode_scanned'
    and param2.key = 'VV_PLAYER_ID' `,
    label: "CVS Kiosk Barcode scanned",
    headers: [
      // { label: "Device ID", key: "player_id" },
      { label: "Device ID", key: "product_id" },
      { label: "Event Count", key: "value" },
    ],
    fetchapi: true,
    requestheaders: {
      "Content-Type": "application/json",
      "Api-Key": "b304d7bf-4c28-4bfb-a387-2408c2c2de6f",
      "Client-ID": "mb872ca6-7b27-4300-b5a6-5b188712fc19",
    },
    customData: ["productName", "category", "listName", "price"],
    appendquery: `group by 1 order by value desc`,
  },
  {
    query: `SELECT param1.value.string_value as outcomeid, event_name,  count(1) AS value
    FROM \`cvs-vividplay.analytics_257379716.events_*\`,
    UNNEST(event_params) AS param1
    where event_name like '%vv_Outcome_%' AND param1.key = 'outcomeid'`,
    label: "CVS Mobile Outcome",
    headers: [
      { label: "Outcome ID", key: "outcomeid" },
      { label: "Event Name", key: "event_name" },
      { label: "Event Count", key: "value" },
    ],
    fetchapi: true,
    requestheaders: {
      "Content-Type": "application/json",
      "Api-Key": "b304d7bf-4c28-4bfb-a387-2408c2c2de6f",
      "Client-ID": "mb872ca6-7b27-4300-b5a6-5b188712fc19",
    },
    customData: ["productName", "category", "listName", "price"],
    appendquery: `group by 1,2 order by value desc`,
  },
   {
    query: `SELECT param1.value.string_value as product, event_name, count(1) AS value
    FROM \`cvs-vividplay.analytics_257379716.events_*\`,
    UNNEST(event_params) AS param1
    where event_name like '%vv_click_url_%' AND param1.key = 'vv_product'`,
    label: "CVS URL Click",
    headers: [
      { label: "Product", key: "product" },
      { label: "Event Name", key: "event_name" },
      { label: "Event Count", key: "value" },
    ],
    fetchapi: true,
    requestheaders: {
      "Content-Type": "application/json",
      "Api-Key": "b304d7bf-4c28-4bfb-a387-2408c2c2de6f",
      "Client-ID": "mb872ca6-7b27-4300-b5a6-5b188712fc19",
    },
    customData: ["productName", "category", "listName", "price"],
    appendquery: `group by 1,2 order by value desc`,
  },
  {
    query: `SELECT param1.value.string_value as outcomeid, event_name,  count(1) AS value
    FROM \`cvs-vividplay.analytics_257379716.events_*\`,
    UNNEST(event_params) AS param1
    where event_name like 'vv_kiosk_outcome_page' AND param1.key = 'outcomeid'`,
    label: "CVS Kiosk Outcome Page",
    headers: [
      { label: "Outcome ID", key: "outcomeid" },
      { label: "Event Name", key: "event_name" },
      { label: "Event Count", key: "value" },
    ],
    fetchapi: true,
    requestheaders: {
      "Content-Type": "application/json",
      "Api-Key": "b304d7bf-4c28-4bfb-a387-2408c2c2de6f",
      "Client-ID": "mb872ca6-7b27-4300-b5a6-5b188712fc19",
    },
    customData: ["productName", "category", "listName", "price"],
    appendquery: `group by 1,2 order by value desc`,
  },
  {
    query: `SELECT event_name, param1.value.int_value AS product_id , param2.value.int_value as barcode_id, param3.value.string_value as mac_id, count(1) AS value
    FROM \`cvs-vividplay.analytics_257379716.events_*\`,
  UNNEST(event_params) AS param1,UNNEST(event_params) AS param2, UNNEST(event_params) AS param3
  WHERE event_name = 'vv_kiosk_product_page'
  and param1.key = 'productId' AND param2.key = 'barcodeId'and param3.key = 'mac_id'`,
    label: "CVS Kiosk Product Page",
    headers: [
      { label: "Product ID", key: "product_id" },
      { label: "Event Name", key: "event_name" },
      { label: "Barcode ID", key: "barcode_id" },
      { label: "Mac ID", key: "mac_id" },
      { label: "Event Count", key: "value" },
    ],
    fetchapi: true,
    requestheaders: {
      "Content-Type": "application/json",
      "Api-Key": "b304d7bf-4c28-4bfb-a387-2408c2c2de6f",
      "Client-ID": "mb872ca6-7b27-4300-b5a6-5b188712fc19",
    },
    customData: ["productName", "category", "listName", "price"],
    appendquery: `group by 1,2,3,4 order by value desc`,
  },
];

